import { render, staticRenderFns } from "./order-modal-deposit-update.vue?vue&type=template&id=5921d27e&scoped=true"
import script from "./order-modal-deposit-update.vue?vue&type=script&lang=js"
export * from "./order-modal-deposit-update.vue?vue&type=script&lang=js"
import style0 from "./order-modal-deposit-update.vue?vue&type=style&index=0&id=5921d27e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5921d27e",
  null
  
)

export default component.exports